import { useMemo } from "react";
import Slider from "react-slick";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { BaseUrl } from "../../helper/BaseUrl";
import ApiRequest from "../../helper/ApiRequest";
import React, { useEffect, useState } from "react";

const ListEndpoint = ApiEndpoints.clientLogo.List;
const asList = (value) => (Array.isArray(value) ? value : []);


export default function LyftTeamlogo({ heading = false, newClass = "", initialData }) {
  const [data, setData] = useState(() => asList(initialData));

  useEffect(() => {
    if (data.length) return;

    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", ListEndpoint);
        const result = response.logos;
        setData(asList(result));
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, [data.length]);

  const settings2 = {
    dots: false,
    arrows: false,
    slidesToShow: 5,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    pauseOnHover: false,
    cssEase: "linear",
    autoplaySpeed: 0,
    speed: 5000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  const half = Math.ceil(data.length / 2);
  const firstHalf = data.slice(0, half);
  const secondHalf = data.slice(half);

  return (
    <section className={`Lyft-teamlogo ${newClass}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {heading && (
              <span className="team-logo-dynamic-head">Teamed up with awesome brands through the years.</span>
            )}
            <Slider className="teamlogo-slider" {...settings2}>
              {firstHalf.map((logo, index) => (
                <div key={index} className="teamlogo-box">
                  <div>
                    <small><img width="175" height="102" src={BaseUrl + logo.logo} alt={logo?.alt_logo || `team logo ${index + 1}`}
                      loading="lazy"
                    /></small>
                    <span>{logo.country}</span>
                  </div>
                </div>
              ))}
            </Slider>
            <Slider className="teamlogo-slider team-log-slide-reverse" {...{ ...settings2, rtl: true }}>
              {secondHalf.map((logo, index) => (
                <div key={index} className="teamlogo-box">
                  <div>
                    <small><img width="175" height="102" src={BaseUrl + logo.logo} alt={logo?.alt_logo || `team logo ${index + 1}`}
                      loading="lazy" /></small>
                    <span>{logo.country}</span>
                  </div>
                </div>
              ))}
            </Slider>
            {/* <Slider className="teamlogo-slider" {...settings2}>
                {data.map((logo, index) => (
                  <div key={index} className="teamlogo-box">
                    <div>
                      <small><img width="175" height="102" src={BaseUrl + logo.logo} alt={ logo?.alt_logo || `team logo ${index + 1}`}
                      loading="lazy"/></small>
                      <span>{logo.country}</span>
                    </div>
                  </div>
                ))}
              </Slider> */}
          </div>
        </div>
      </div>
    </section>
  );
}
